import React from 'react';
import {
  useAlisaAudioManagerActions,
  useAlisaAudioManagerState,
} from '../../model';

const Control = ({ render }) => {
  const playingShutdownId = useAlisaAudioManagerState();
  const { onPlay, onStop } = useAlisaAudioManagerActions();

  return render({
    onPlay,
    onStop,
    playingShutdownId,
  });
};

export default Control;
